import React from "react";
import { Box, Typography } from "@mui/material";
import styles from "./_tab-panel.module.scss";
import classNames from 'classnames';
import { CSSProperties } from "react";
export interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
  showContactHeader?: boolean;
  style?: CSSProperties;
  className?: string;
}

export default function TabPanel(props: TabPanelProps) {
  const { children, value, index, style, className, ...other } = props;
  return (
    <div
      style={style}
      className={props.showContactHeader ? classNames(styles.tabPanel, styles.contactHeader, className) : styles.tabPanel}
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}
